<template>
  <div>
    <Scroll>
    <Card dis-hover>
      <p slot="title">价格规则（{{ Classification }}）</p>
      <div v-for="item of lists"
           :key="item.Price_rules_ID"
           :class="item.Price_rules_ID === CurrentRule.Price_rules_ID?'ActiveMaterialCategory':'MaterialCategory'"
           @click="PriceRuleSelectHandleClick(item)"
           >
        <List>
          <ListItem>
            <ListItemMeta :description="item.Price_rulesName +'（备注：' + item.Remarks + '）'"/>
            <!-- <span>{{ item.Remarks }}</span> -->
          </ListItem>
        </List>
      </div>
    </Card>
    </Scroll>
  </div>
</template>

<script>
export default {
  name: 'PriceRulesList',
  props: {
    lists: Array,
    Classification: String,
    CurrentRule: {
      Price_rules_ID: '',
      Price_rulesName: '',
      Remarks: ''
    }
  },
  methods: {
    //   点击选择后回调
    PriceRuleSelectHandleClick (item) {
      this.$emit('PriceRuleSelectHandleClick', item)
    }
  }
}
</script>
<style lang="scss" scoped>
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-title {
  color: #288cf0;
}
.ActiveMaterialCategory ::v-deep .ivu-list-item-meta-description {
  color: #288cf0;
}
.MaterialCategory {
  &:hover {
    background: #f3f3f3;
    cursor: pointer;
  }
}
.ActiveMaterialCategory {
  background: #f0faff;
  color: #288cf0;
  &:hover {
    cursor: pointer;
  }
}
</style>
